import { BcfActivatedRouteContract } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-route';
import { Params } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/types';
import { ActivatedRoute } from '@tmf-shared-platform/activated-route/activated-route';
import { Observable } from 'rxjs';

type RouteData = Record<string, any>;

export class BcfActivatedRouteAdapter implements BcfActivatedRouteContract {
  constructor(private _activatedRoute: ActivatedRoute) {}

  public get fragment(): Observable<string | undefined> {
    return this._activatedRoute.fragment$;
  }
  public get queryParams(): Observable<Params> {
    return this._activatedRoute.queryParams$;
  }
  public get params(): Observable<Params> {
    return this._activatedRoute.params$;
  }

  public get data(): Observable<RouteData> {
    return this._activatedRoute.data$;
  }

  public dataTyped<T = RouteData>(): Observable<T> {
    return this.data as Observable<T>;
  }
}
